type AdminErrorMessageProps = {
  message: string | null | undefined;
};

export default function AdminErrorMessage({ message }: AdminErrorMessageProps) {
  if (!message) return null;
  return (
    <p className="text-sm text-danger" role="alert">
      {message}
    </p>
  );
}
